import { z } from 'zod';
import * as m from '@/paraglide/messages.js';

export function validateName(value: string) {
  return !value.trim() || value.trim().length > 200 ? m.validation_name_length() : undefined;
}

export function validateEmail(value: string, required = true) {
  const email = value.trim();
  if (!email && !required) return undefined;
  return email.length > 320 || !z.email().safeParse(email).success
    ? m.person_validation_email()
    : undefined;
}
